/**
 * Слой проводки на холсте: кабели между приборами по потолку.
 *
 * Трасса каждого кабеля считается из положения приборов и его точек, поэтому
 * передвинул розетку — кабель потянулся за ней. Кабель, у которого пропал один
 * из приборов, не рисуется (стор такие и не хранит). Черновик прокладываемого
 * кабеля рисует холст отдельно — он не часть слоя.
 */
import type { PointerEvent } from "react";
import { cableItemById } from "@/shared/catalog";
import { cableRoute, type Cable, type ItemsLayer, type WallGraph } from "../../plan";
import { CableShape } from "@/widgets/catalog";
import { SelectionKind, Tool, useEditorStore } from "../../editor";

interface Props {
	graph: WallGraph;
	/** Слой электрики: концы кабелей — приборы на стенах и светильники на потолке */
	electrical: ItemsLayer;
	cables: Cable[];
	mmPerPx: number;
	onCablePointerDown: (e: PointerEvent<Element>, cable: Cable) => void;
}

export const CablesLayer2D = ({
	graph,
	electrical,
	cables,
	mmPerPx,
	onCablePointerDown,
}: Props) => {
	const selection = useEditorStore((s) => s.selection);
	const tool = useEditorStore((s) => s.tool);
	return (
		<g>
			{cables.map((cable) => {
				const route = cableRoute(graph, electrical, cable);
				if (!route) return null;
				return (
					<CableShape
						key={cable.id}
						cableId={cable.id}
						color={(cable.material && cableItemById(cable.material)?.color) || "#64748b"}
						route={route}
						selected={selection?.kind === SelectionKind.Cable && selection.id === cable.id}
						mmPerPx={mmPerPx}
						interactive={tool === Tool.Select || tool === Tool.Erase}
						onPointerDown={(e) => onCablePointerDown(e, cable)}
					/>
				);
			})}
		</g>
	);
};
